import { BiChevronDown } from "react-icons/bi";
import Button from "../../../../../components/world/rmc/Button";
import {
  Arrow,
  Card,
} from "../../../../../components/svg/worldSvgs/rmc/Achievements";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { TransactionBadge } from "../../../../../components/world/rmc/TransactionBadge";
import { useContext, useEffect, useRef, useState } from "react";
import { useGetAudience } from "../../../../../api/audience/useGetAudience";
import { formatAmount, formatToNaira } from "../../../../../utils";
import { useFundWallet } from "../../../../../api/fundWallet";
import clsx from "clsx";
import { FilterDropdown } from "../../../../../components/filterDropdown";
import { SuccessModal } from "../../modals/successModal";
import { RmcContext } from "../../../../../components/context/RmcContext";
import { AnimatePresence } from "framer-motion";

const filters = [
  {
    key: "Today",
    value: "daily",
  },
  {
    key: "This Week",
    value: "weekly",
  },
  {
    key: "This Month",
    value: "monthly",
  },
  {
    key: "All Time",
    value: "",
  },
];

export const Wallet = ({ primaryColor = "#FFD700" }) => {
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const [type, setType] = useState(filters[0]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const { brandId, rmcAudience, slug } = useContext(RmcContext);
  const { GetAudience, loading } = useGetAudience();
  const { getTransactionHistory, transactionHistory, loadingHistory } =
    useFundWallet();
  useEffect(() => {
    if (brandId && !hasFetched.current) {
      hasFetched.current = true;
      GetAudience(brandId, false);
    }
  }, [brandId]);
  useEffect(() => {
    if (brandId) {
      getTransactionHistory(type.value);
    }
  }, [type]);
  const loadingLength = new Array(8).fill("_");
  return (
    <div className="px-4 mt-5">
      <div className="bg-blackhue-rmc_hue rounded-[10px] p-5 mb-12">
        <div className="w-fit mb-4">
          <p className="text-xs text-[#FFFFFF80] mb-1.5">Pts Balance</p>
          {loading ? (
            <div className="h-7 bg-gray-600 rounded animate-pulse w-[100px]"></div>
          ) : (
            <p className="text-lg text-white font-semibold leading-tight ">
              {rmcAudience?.points || 0} pts
            </p>
          )}
        </div>
        <div className="flex justify-between items-end">
          <div className="w-fit">
            <p className="text-xs text-[#FFFFFF80] mb-1.5">Cash balance</p>
            {loading ? (
              <div className="h-7 bg-gray-600 rounded animate-pulse w-[100px]"></div>
            ) : (
              <p className="text-lg text-white font-semibold leading-tight">
                ₦{formatAmount(rmcAudience?.wallet_balance) ?? 0}
              </p>
            )}
          </div>
          <Button
            onClick={() => {
              navigate(`/worlds/${slug}/achievements/fund-wallet`);
            }}
            text="Fund Wallet"
            style={{ backgroundColor: primaryColor }}
          />
        </div>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-lg font-semibold text-white ">Transaction History</p>
        <FilterDropdown
          options={filters}
          selectedOption={type}
          setSelectedOption={setType}
          selectedOptionClass={clsx(
            "rmc_select_selected",
            type?.value ? "text-white" : "text-gray-400",
          )}
          selectedClass="bg-[#1B2033]"
          dropdownClass="rmc_select_dropdown text-xs"
          optionsClass="rmc_select_options"
          trailingIcon={
            <BiChevronDown
              size={16}
              className="text-[#FFFFFF4D] transition-transform duration-200"
            />
          }
        />
      </div>
      <div
        className={clsx(
          !loadingHistory && "p-5",
          "bg-blackhue-rmc_hue rounded-[10px] mt-5",
        )}
      >
        <div className="flex flex-col gap-5 overflow-y-scroll hidden-scrollbar max-h-[40vh] ">
          {loadingHistory ? (
            <div className="space-y-3.5 p-5 ">
              {loadingLength.map((_, i) => (
                <div
                  key={i}
                  className="h-[40px] bg-gray-600 rounded-lg animate-pulse"
                ></div>
              ))}
            </div>
          ) : transactionHistory.length === 0 ? (
            <div className="flex justify-center items-center h-[40vh] flex-col gap-3">
              <p className="tracking-tighter text-2xl font-semibold text-white mx-0 text-center">
                No Transaction History
              </p>
              <p className="text-sm font-medium mt-1 text-[#FFFFFF80] w-full max-w-[300px] text-center">
                Once you fund your wallet, your transaction history will show up
                here.
              </p>
            </div>
          ) : (
            transactionHistory?.map((x, i) => {
              return (
                <div
                  onClick={() => setSelectedTransaction(x)}
                  key={i}
                  className="flex justify-between items-center  gap-5 cursor-pointer "
                >
                  <div className="flex items-center gap-2.5">
                    <div
                      className="rounded-[5px] mx-auto p-1.5"
                      style={{ backgroundColor: `${primaryColor}33` }}
                    >
                      {x.payment_method === "card" ? (
                        <Card color={primaryColor} />
                      ) : (
                        <Arrow
                          className={x.is_credit === 0 ? "rotate-180" : ""}
                          stroke={x.is_credit === 0 ? "#F54B5F" : primaryColor}
                        />
                      )}
                    </div>
                    <div className="flex flex-col">
                      <p className="leading-tight mb-1 text-sm text-white font-medium hover:underline">
                        {x.payment_method === "card"
                          ? "Card payment"
                          : "Transfer Payment"}
                      </p>
                      <span className="text-xs font-semibold text-[#FFFFFF99]">
                        ref: {x.payment_reference}
                      </span>
                      <span className="text-xs text-[#FFFFFF99] font-light">
                        {dayjs(x.created_at).format("D MMM YYYY h:mm A")}
                      </span>
                    </div>
                  </div>
                  <div>
                    <p className="leading-tight text-nowrap mb-1 text-sm text-white font-medium">
                      {formatToNaira(x.amount)}
                    </p>
                    <TransactionBadge status={x.status} />
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
      <AnimatePresence>
        {selectedTransaction && (
          <SuccessModal
            action="Payment"
            transaction={selectedTransaction}
            handleDone={() => setSelectedTransaction(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};
